import type { DashboardTileContentProps } from './dashboard-tile-content.types.ts';

export function DashboardTileContent({ children, className }: DashboardTileContentProps) {
  return <div className={`k-tilelayout-item-body k-card-body ${className}`}>{children}</div>;
}
